import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as User from '../../helpers/User';
import * as Common from '../../helpers/Common';


const $= window.$;

class ObserverForm extends Component {
	constructor(props) {
		super(props);
        this.state={
          txtname : '',
          txtemail: '',
          lstrelation:'',
          OptGender:'1',
          txtphoneISD1:'',
          txtphoneSTD:'',
          txtphone :''

        };
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
       	this.clearForm = this.clearForm.bind(this);


	}

	handleChange(e){
		this.setState({
			[e.target.name]:e.target.value
		})
	}

	clearForm(){



		var txtname =  $("#txtname").val("");
		var txtemail = $("#txtemail").val("");
		var lstrelation = $("#lstrelation").val("");
		var OptGender = $("#OptGender").val("");
		var txtphoneISD1 = $("#txtphoneISD1").val("");
		var txtphoneSTD = $("#txtphoneSTD").val("");
		var txtphone = $("#txtphone").val("");
		 this.setState({
	      txtname : '',
          txtemail: '',
          lstrelation:'',
          OptGender:'1',
          txtphoneISD1:'',
          txtphoneSTD:'',
          txtphone :''
	  });
	}


	onSubmit(e){
		Common.reactLoader("show", "Please wait...");

		var email =  this.state.txtemail;
		let product_name =  Common.getUserData("productName", true);
		let learnerID = Common.getUserData("id", true);
		//alert(product_name);
		//var product_name = 'MBA Common';

		fetch(Config.domainUrl+'add-observer', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    assessor_name: this.state.txtname,
			        email: this.state.txtemail,
			        uname: this.state.txtemail,
			        relationship: this.state.lstrelation,
			        gender: this.state.OptGender,
			        isd_code: this.state.txtphoneISD1,
			        //std_code: this.state.txtphoneSTD,
			        phone: this.state.txtphone,
			        is_mentor:1,
			        is_approved:0,
			        is_approved_mentor:0,
			        awaiting_deleted:0,
			        learner_id:learnerID,
			        product_name:product_name
                  })
                }).then((response) => response.json())
               .then((responseJson) => {

               	  Common.reactLoader("hide");
               	  //alert(JSON.stringify(responseJson));
         			if (responseJson.status == 0) {
         				if(responseJson.errors == '<ul><li class=\"error\">custom</li></ul>'){
         					this.clearForm();
         					Common.message("", 'Your request has been sent successfully.  When the person accepts your request, he/she will become your Observer.', "success");
         				}
         				else{
				        	Common.message(responseJson.message, responseJson.errors, "error");
         				}
				      } else {
				         this.clearForm();
				         Common.message("", 'Your request has been sent successfully.  When the person accepts your request, he/she will become your Observer.', "success");


				      }




   				 });






	}





    componentDidMount() {

    }

		render() {

			const {formtodata} = this.props;
        	//alert(JSON.stringify(formtodata));
        	let rows = null;
        	if(formtodata != undefined || formtodata != null){
        	rows = formtodata.map((formdata,i) => {
        		let row = '';
        		if(formdata.relations!=undefined){
	        		row = formdata.relations.map((rela,k) => {
	        			return (
	    						<option key={`observerkeys_${k}`} value={rela}>{rela}</option>
	        				)
	        		});
        		}
        		return(
    				<select name="lstrelation" key={`selectformobserver_${i}`} id="lstrelation" onChange={e=>this.handleChange(e)}>
    					<option value=''>--Select--</option>
			            {row}
			        </select>
        		)
			 });
			}
			let country = '';
			if(formtodata != undefined || formtodata != null){
				country = formtodata.map((formdata,index) => {
				 	let row = '';
				 	let value = index+1;
				 	if(formdata.country!=undefined){
		        		row = formdata.country.map((country) => {
		        			return (
		    						<option  key={`selectform${country.printableName}`}  value={country.numCode}>{country.printableName+' - '+country.numCode}</option>
		        				)
		        		});
				 	}
	        		return(
	    				<select name="txtphoneISD1" key={`formkey_${value}`} id="txtphoneISD1" onChange={e=>this.handleChange(e)}>
	    					<option value=''>--Select--</option>
					    	{row}
					    </select>
	        		)
				 });
			}

			return (
				<div className="tabgrey">
				    <div className="observer-msg" style={{display:'none'}}></div>
				    <span className="add-observer" style={{display:'none'}}></span>
				        <input name="customerid" id="customerid"  type="hidden" />
				        <div className="new-observer">
				            <div className="newobserver-left">
				                <ul>
				                    <li className="label"><label>Name <span className="redstar">*</span></label></li>
				                    <li>
				                        <input name="txtname" type="text" id="txtname"  onChange={e=>this.handleChange(e)}  />
				                        <div id="divName" className="error"></div>
				                    </li>
				                    <li className="label"><label>Email ID <span className="redstar">*</span></label></li>
				                    <li>
				                        <input name="txtemail" type="text" id="txtemail" className="textbox_gray" onChange={e=>this.handleChange(e)}  />
				                        <div id="msgemail" className="error"></div>
				                    </li>
				                    <li className="label"><label>Relationship <span className="redstar">*</span></label></li>
				                    <li>
				                       {rows}
				                        <div id="divDesignation" className="error"></div>
				                    </li>
				                </ul>
				            </div>
				            <div className="newobserver-right">
				                <ul>
				                    <li className="label"><label>Gender <span className="redstar">*</span></label></li>
				                    <li className="ratiobg">
				                            <input name="OptGender" className="rdbtn" type="radio" value="1"   checked={this.state.OptGender === '1'} onChange={e=>this.handleChange(e)}/>Male
				                            <input name="OptGender" className="rdbtn" type="radio" value="0"    checked={this.state.OptGender === '0'} onChange={e=>this.handleChange(e)}/>Female
				                    </li>
				                    <li className="label"><label>Contact No <span className="redstar">*</span> </label>
				                    </li>
				                    <li>
				                      {country}
				                      <div id="msgphoneISD1" className="error"></div>
				                    </li>
				                    <li className="label"><label></label></li>
				                    <li>
				                        {/* <div className="country-code">
				                            <input name="txtphoneSTD" type="text" className="textbox_gray" id="txtphoneSTD"  maxLength="6" style={{width:'70%', marginRight:'4px'}} onChange={e=>this.handleChange(e)}/> <span> - </span>
				                            <span>STD Code</span>
				                        </div> */}
				                        <div className="phone-code">
				                            <input name="txtphone" type="text" className="textbox_gray" id="txtphone" maxLength="10" onChange={e=>this.handleChange(e)}/><br/>
				                            <span>10 digit Mobile Number</span>
				                        </div>
				                        <div id="msgphoneSTD" className="error"></div>
				                        <div id="msgphone" className="error"></div>
				                    </li>

				                    <li className="label"></li>
				                    <li><input type="submit" name="btnmentors" value="Add Observer" onClick={(e)=>this.onSubmit(e)} alt="Add Observer" title="Add Observer" /></li>
				                </ul>
				            </div>
				        </div>
				</div>
			);
		}
}

export default ObserverForm;



// WEBPACK FOOTER //
// ./src/personal_interactions/observer/ObserverForm.js